/**
 * Endereços do U1 no cliente.
 *
 * ADR-008: um domínio só. Front, API e stream compartilham origem, então tudo
 * aqui é caminho relativo — nada de base URL configurável. Isso elimina CORS e
 * faz o cookie de sessão funcionar sem `SameSite=None`. Em desenvolvimento o
 * Vite encaminha `/v1/u1` (inclusive o upgrade de WebSocket) para o Presence.
 *
 * Deliberadamente não lemos `import.meta.env`: o tsconfig do app não inclui os
 * tipos do Vite, e um endereço configurável abriria de novo a porta que a
 * ADR-008 fechou.
 */

export const U1_API_PATH = '/v1/u1';
export const U1_STREAM_PATH = '/v1/u1/stream';

/** Endpoint de bootstrap de sessão. */
export const U1_SESSIONS_URL = `${U1_API_PATH}/sessions`;

/**
 * URL absoluta do stream. É montada a partir de `location` porque o WebSocket
 * não aceita caminho relativo, e o esquema precisa acompanhar o da página
 * (`https` → `wss`) ou o navegador bloqueia o conteúdo misto.
 */
export function urlDoStream(): string {
  if (typeof window === 'undefined') {
    throw new Error('urlDoStream() só existe no navegador — não há `location` aqui.');
  }
  const esquema = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${esquema}//${window.location.host}${U1_STREAM_PATH}`;
}
